import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-drop-down-list",
  "use": "svgIcon-drop-down-list-usage",
  "viewBox": "-14.333 0 50.333 36",
  "content": "<symbol viewBox=\"-14.333 0 50.333 36\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-drop-down-list\"><path d=\"M0 2.6h36v4H0zM0 29.4h36v4H0M0 16h36v4H0M-14.333 28.75l4.417 6.75 4.583-6.75\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol